import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export const MAX_COMPARE = 4;

export interface CompareItem {
  slug: string;
  title: string;
  cover: string | null;
  category: string;
}

interface CompareState {
  items: CompareItem[];
  toggle: (item: CompareItem) => "added" | "removed" | "full";
  remove: (slug: string) => void;
  clear: () => void;
}

/** Up to 4 listings to compare, remembered in this browser only (a convenience, not account data). */
export const useCompare = create<CompareState>()(
  persist(
    (set, get) => ({
      items: [],
      toggle: (item) => {
        const items = get().items;
        if (items.some((i) => i.slug === item.slug)) {
          set({ items: items.filter((i) => i.slug !== item.slug) });
          return "removed";
        }
        if (items.length >= MAX_COMPARE) return "full";
        set({ items: [...items, item] });
        return "added";
      },
      remove: (slug) => set({ items: get().items.filter((i) => i.slug !== slug) }),
      clear: () => set({ items: [] }),
    }),
    {
      name: "rs-compare",
      storage: createJSONStorage(() => {
        try {
          return window.localStorage;
        } catch {
          return { getItem: () => null, setItem: () => undefined, removeItem: () => undefined };
        }
      }),
    },
  ),
);
